import { NavLink } from "react-router-dom";
import { Home, CalendarDays, BarChart3, User } from "lucide-react";

const ITEMS = [
  { to: "/", label: "Accueil", icon: Home, id: "accueil", end: true },
  { to: "/matchs", label: "Matchs", icon: CalendarDays, id: "matchs" },
  { to: "/statistiques", label: "Statistiques", icon: BarChart3, id: "statistiques" },
  { to: "/profil", label: "Profil", icon: User, id: "profil" },
];

export const BottomNav = () => (
  <nav data-testid="bottom-nav" className="fixed bottom-0 inset-x-0 z-40 mx-auto max-w-md bg-white/90 backdrop-blur-xl border-t border-slate-200 px-2 pt-2 pb-[max(0.5rem,env(safe-area-inset-bottom))] flex justify-around">
    {ITEMS.map(({ to, label, icon: Icon, id, end }) => (
      <NavLink key={to} to={to} end={end} data-testid={`nav-${id}`}
        className={({ isActive }) => `flex flex-col items-center gap-1 px-3 py-1.5 rounded-xl text-[11px] font-semibold transition-colors ${isActive ? "text-cyan-600 bg-cyan-50" : "text-slate-400 hover:text-slate-600"}`}>
        {({ isActive }) => (
          <>
            <Icon className={`w-5 h-5 transition-transform ${isActive ? "scale-110" : ""}`} strokeWidth={isActive ? 2.5 : 2} />
            {label}
          </>
        )}
      </NavLink>
    ))}
  </nav>
);
